module.exports = __webpack_public_path__ + "media/bgm.6e5119a2.mp3";